import React from 'react';

class Tabs extends React.Component{

    static defaultProps = {
        items: [
            {label:"Tab 1", link:"tab_1", content:"This is the text content of tab 1."},
            {label:"Tab 2", link:"tab_2", content:"This is the text content of tab 2 the second tab."},
            {label:"Tab 3", link:"tab_3", content:"This is the text content of tab 3..."},
            {label:"Tab 4", link:"tab_4", content:"This is the text or <b>HTML</b> content of tab 4..."},
            {label:"Tab 5", link:"tab_5", content:"This is the text content of tab 5..."}
        ],
        activeIndex: 0,
        className: "",
        navClasses: "nav nav-tabs",
        contentClasses: "tab-content py-3"
    };
    
    render(){
        const { items, activeIndex } = this.props;
        return (
            <div className={this.props.className}>
                <ul className={this.props.navClasses}>
                    {items && items.length > 0 ? items.map((item,key) =>
                      <li className="nav-item" key={key}>
                        <a className={(key===activeIndex)?'nav-link active':'nav-link'} data-toggle="tab" href={'#'+item.link}>{item.label}</a>
                      </li>)
                    :null}
                </ul>
                <div className={this.props.contentClasses}>
                    {items && items.length > 0 ? items.map((item,k) => (
                    <div key={k} className={'tab-pane fade show ' + (k===activeIndex?'active':'')} id={item.link} role="tabpanel" dangerouslySetInnerHTML={{ __html: item.content }}>
                    </div>
                    )):null}
                </div>
            </div>
        );
    }
}

export default Tabs;
